import Icon from '../components/Icon.vue'

Icon.register({
  radiation: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M167.8 256.2H16.2C7.1 256.2-0.6 263.9 0 273 5.1 348.8 44.4 415.2 102.5 457.2 109.9 462.5 120.4 460.1 125.2 452.4L205.6 324C183 309.7 167.8 284.8 167.8 256.2zM205.6 188.5C217.9 180.8 232.4 176.1 248 176.1S278 180.8 290.4 188.5L370.8 60C375.6 52.3 373.2 41.9 365.2 37.6 330.3 18.8 290.4 8 248 8S165.7 18.8 130.8 37.6C122.8 41.9 120.4 52.4 125.2 60L205.6 188.5zM248 208.2C221.5 208.2 200 229.7 200 256.2S221.5 304.2 248 304.2 296 282.7 296 256.2 274.5 208.2 248 208.2zM479.8 256.2H328.2C328.2 284.8 313 309.7 290.4 323.9L370.8 452.3C375.6 460 386.1 462.5 393.5 457.1 451.6 415.1 490.9 348.7 496 272.9 496.6 263.9 488.9 256.2 479.8 256.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/radiation.js
// module id = 8ty0
// module chunks = 144